import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './ChecklistModal.module.css';

function ChecklistUnsavedWarning({ handler }) {
	return (
		<Dialog
			open={true}
			onClose={handler?.onCancel}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Unsaved changes
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							You are about to leave this content without saving.
							All changes will be lost. Do you want to leave
							without saving?
						</DialogContentText>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button
					variant="outlined"
					size="small"
					onClick={handler?.onCancel}
				>
					Cancel
				</Button>
				<Button
					variant="outlined"
					size="small"
					onClick={handler?.onLeaveWithoutSaving}
				>
					Leave without saving
				</Button>
				<Button
					variant="contained"
					size="small"
					onClick={handler?.onLeaveAfterSave}
				>
					Save Changes
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ChecklistUnsavedWarning;
